import { AppBar, styled } from '@mui/material';

export const AppTopBar = styled(AppBar)(({ theme }) => ({
  position: 'static',
  backgroundColor: theme.palette.primary.dark,
}));